import { Box, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import OtherBankIcon from '../../Checking/components/BankIcons';
import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

export const AllAccountsAssignedRow: React.FC = () => (
  <Box css={{ padding: 'space.300', display: 'flex' }}>
    <OtherBankIcon />
    <Box css={{ display: 'flex', flexDirection: 'column', marginLeft: 'space.100' }}>
      <Text variant="text100">All of your connected accounts have been assigned to goals.</Text>
      <Text variant="text50" color="text.weak">
        Learn more about how{' '}
        <SambaAutoLink
          to={urlBuilder.appExternalAccountSetup.absolute()}
          onClick={() => trackClick({ name: 'ElementClicked' })}
        >
          we factor connected accounts
        </SambaAutoLink>{' '}
        into your advice
      </Text>
    </Box>
  </Box>
);
